<template>
  <div class="field mb-2">
    <FieldLabel>{{ label }}</FieldLabel>
    <div
      class="input-wrapper d-flex w-100"
      :class="{ focus: focus || pickerOpen }"
    >
      <input
        class="input border-0 w-100 py-0 px-2"
        type="text"
        :placeholder="placeholder"
        :value="fieldValue"
        @keyup="keyHandler"
        @keydown.tab="mainCloseHandler"
        @keydown.enter="mainCloseHandler"
        @keydown.esc="closePicker"
        @click="clickHandler"
        @focus="focusHandler"
        @blur="focus = false"
      >
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import { DEFAULT_DATE_FORMAT, VALID_DATE_FORMATS } from '../../general/helper'
import FieldLabel from './FieldLabel.vue'

dayjs.locale('de')

// TODO: clean up, not best practice
const defaultCloseHandler = (props: any) => {
  if (props.fieldValue) {
    let date

    for (const fmt of VALID_DATE_FORMATS) {
      date = dayjs(props.fieldValue, fmt.format, true)

      if (date.isValid()) {
        break
      }
    }

    if(!!date) {
      props.valueChanged(props.fieldName, date.format(DEFAULT_DATE_FORMAT))
    }
  }

  props.closePicker()
}

export default {
  components: { FieldLabel },

  props: {
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    fieldName: { type: String, default: '' },
    fieldValue: { type: String, default: '' },
    valueChanged: { type: Function, default: () => console.log('valueChanged not implemented') }, // eslint-disable-line no-console
    clicked: { type: Function, default: () => console.log('clicked not implemented') }, // eslint-disable-line no-console
    closePicker: { type: Function, default: () => console.log('closePicker not implemented') }, // eslint-disable-line no-console
    pickerOpen: { type: Boolean, default: false },
    closeHandler: { type: Function, default: (props: any) => defaultCloseHandler(props) },
  },

  data: () => {
    return {
      focus: false,
    }
  },

  methods: {
    mainCloseHandler() {
      this.closeHandler(VALID_DATE_FORMATS, DEFAULT_DATE_FORMAT)
    },
    keyHandler(event: KeyboardEvent) {
      this.valueChanged(this.fieldName, (event.target as HTMLInputElement).value)
    },
    clickHandler(event: MouseEvent) {
      if (this.pickerOpen) {
        event.stopPropagation()
      }
    },
    focusHandler() {
      this.clicked()
      this.focus = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.field {
  flex: 1;
}

.input-wrapper {
  height: 32px;
  border: 2px solid $color-expinet-dark-gray;

  &:hover, &.focus {
    border: 2px solid $color-expinet-blue;
  }
}

.input {
  color: $color-aida-black;
  box-shadow: none;

  &:focus {
    outline: 0;
  }
}
</style>
